// Code to display past statements for user
// import { useState } from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useTranslation } from "react-i18next";

export const PastStatement = ({ stub }) => {
  const { t } = useTranslation();
  // console.log(stub, 'stub')

  const downloadPaystub = (id) => {
    window.open(`/paystub/pdf/${id}`, "_blank");
  };

  return (
    <Box
      className="tm-stub-content"
      sx={{
        borderRadius: "0.25em",
        border: "1px solid #000",
        padding: "0.5em",
      }}
    >
      <Box
        className="tm-stub-header"
        sx={{
          flex: "3",
          fontSize: "1rem",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: "0.75rem",
          }}
        >
          {stub && stub.pay_date ? stub.pay_date : t("statement.na")}
        </Typography>
        <Typography variant="body1">
          {stub && stub.type === "hourly"
            ? `${t("statement.hours")}: ${stub.total_hours}`
            : null}
        </Typography>
      </Box>
      <Box
        className="tm-stub-body"
        sx={{
          flex: "2",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          fontSize: "0.75rem",
          marginRight: "2em",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: "0.6rem",
          }}
        >
          {t("statement.takeHome")}
        </Typography>
        <Typography variant="body1">
          ${stub && stub.net_pay ? stub.net_pay : t("statement.na")}
        </Typography>
      </Box>
      <Box
        sx={{
          fontSize: "0.6rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <button onClick={() => downloadPaystub(stub.id)}>
          <FileDownloadOutlinedIcon />
        </button>
      </Box>
    </Box>
  );
};

export default PastStatement;
